<template>
    <div class="banner_box">
        <img class="banner_img" :src="bannerImgUrl" alt="">
    </div>
</template>
<script>
export default {
    props:{
        bannerImgUrl:{}
    },
    data(){
        return{
        }
    },
    // 监听路由变化
    watch: {
        $route: "urlName",
    },
    created(){
    },
    methods:{
      
       
    }
}
</script>
<style lang="scss" scoped>


        .banner_box {
            min-width: 1200px;
            height: 540px;
            .banner_img{
                width: 100%;
                height: 540px;
            }
        }
</style>